<template>
  <div>
    <div class="my-4 mx-2">
      <div v-if="inscription.lock_select_parcours">
        <v-alert border="start" border-color="red-darken-4" density="compact" class="mb-2">
          <span v-if="!is_dossard_bourse_mode">Vous ne pouvez pas modifier le parcours de ce coureur car il fait parti
            d'une
            équipe.</span>
          <span v-else>Vous ne pouvez pas modifier le parcours d'un dossard en vente en bourse.</span>
        </v-alert>
      </div>
      <div v-if="inscription.has_courses()">
        <div class="ml-2 my-2">
          <div v-for="(course, index_choix_course) in inscription.list_courses.list" :key="index_choix_course">
            <CheckboxSelectionParcours :item="course" @onToggle="updateSelectionCourse(index_choix_course)"
              :lock_select_parcours="inscription.lock_select_parcours">
            </CheckboxSelectionParcours>
          </div>
        </div>
      </div>

      <div v-if="inscription.has_packs_courses() && !inscription.lock_select_parcours">
        <div>Ou sélectionnez un pack de course:</div>
        <div class="ml-2 my-2">
          <div v-for="(pack, index_choix_pack) in inscription.list_packs_courses.list" :key="index_choix_pack">
            <CheckboxSelectionPack :item="pack" :inscription="inscription"
              @onToggle="updateSelectionPack(index_choix_pack)">
            </CheckboxSelectionPack>
          </div>
        </div>
      </div>
      <WarningBeforeContinue :allow_inscription_non_sportive="allow_inscription_non_sportive"
        :warning_no_course_selected="warning_no_course_selected"
        :warning_no_course_available="warning_no_course_available"
        :warning_no_forfait_selected="warning_no_forfait_selected">
      </WarningBeforeContinue>


      <div class="mb-4" v-if="has_remboursement && has_credit">
        <v-alert border="start" border-color="primary-dark" elevation="1">En changeant pour un parcours moins cher, vous
          bénéficiez d'un crédit de <b>{{ has_credit }}€</b>. Il peut être utilisé tout de suite pour ajouter des
          options,
          ou
          ce crédit sera <b>perdu et non remboursé</b>.</v-alert>
      </div>

      <v-alert border="start" border-color="red-darken-4" class="mb-2" v-for="(error, index_error) in errors"
        :key="index_error">
        {{ error }}
      </v-alert>
      <v-alert v-if="!can_continue" border="start" border-color="primary-dark">Vous devez sélectionner un
        parcours pour continuer</v-alert>

      <!-- <div class="d-flex justify-center">

      <SportipsButton v-if="can_continue" icon="mdi-arrow-down" @onClick="goToNextStep" action-button mobile-full-width>
        Passer à l'étape
        suivante
      </SportipsButton>


    </div> -->
    </div>
    <NavigationStepButtons :canContinue="can_continue" :canGoBack="false" @goToNextStep="goToNextStep"
      @goToPreviousStep="goToPreviousStep" class="bg-spo-light" />
  </div>

</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useCoursesStore } from "@/stores/coursesStore";
import { useBookingStore } from "@/stores/bookingStore";
import CheckboxSelectionParcours from "./SelectionParcours/CheckboxSelectionParcours.vue";
import CheckboxSelectionPack from "./SelectionParcours/CheckboxSelectionPack.vue";
import WarningBeforeContinue from "./SelectionParcours/WarningBeforeContinue.vue";
import NavigationStepButtons from "./InscriptionItem/NavigationStepButtons.vue";
export default {
  props: ["item", "initial_commande_inscription"],
  components: { CheckboxSelectionParcours, CheckboxSelectionPack, WarningBeforeContinue, NavigationStepButtons },
  data() {
    return {
      inscription: {},
      errors: [],
    };
  },
  computed: {
    ...mapStores(useMainStore, useCoursesStore, useBookingStore),
    can_continue() {
      if (this.initial_commande_inscription && this.warning_no_course_selected) return false;
      if (this.warning_no_course_available && !this.allow_inscription_non_sportive) return false;
      if (this.warning_no_course_selected && !this.allow_inscription_non_sportive) return false;
      return true;
    },
    allow_inscription_non_sportive() {
      return !this.mainStore.disable_inscription_non_sportive;
    },
    is_dossard_bourse_mode() {
      return this.mainStore.dossard_bourse_mode;
    },
    warning_no_course_selected() {
      const is_parcours_billetterie = this.mainStore.parcours_billetterie_mode;
      if (is_parcours_billetterie) return false;
      const nb_course_selected = this.inscription.list_courses.count_selected();
      return nb_course_selected == 0;
    },
    warning_no_forfait_selected() {
      const is_parcours_billetterie = this.mainStore.parcours_billetterie_mode;
      if (!is_parcours_billetterie) return false;
      const nb_course_selected = this.inscription.list_courses.count_selected();
      return nb_course_selected == 0;

    },
    warning_no_course_available() {
      const courses_availables = this.inscription.list_courses.get_courses_selectionnables(this.mainStore.module.status,
        this.mainStore.view_as_admin,
        this.mainStore.inscription_as_admin,
        this.mainStore.inscription_vip,
        this.mainStore.module.is_complet,
        this.mainStore.bookingSystem?.groupe);
      return courses_availables.length == 0;

    },

    has_remboursement() {
      if (!this.bookingStore.initial_commande_inscription) return false;
      if (this.bookingStore.initial_commande_inscription.prix && parseFloat(this.bookingStore.initial_commande_inscription.prix) > 0) return parseFloat(this.bookingStore.initial_commande_inscription.prix);
      return false;
    },
    has_credit() {
      if (!this.bookingStore.initial_commande_inscription) return false;
      if (this.bookingStore.initial_commande_inscription.prix && this.inscription.list_courses.cart) {
        if (this.inscription.list_courses.cart.nb_articles == 0) {
          return false;
        }
        let credit = parseFloat(this.bookingStore.initial_commande_inscription.prix) - parseFloat(this.inscription.list_courses.cart.prix);
        if (credit > 0) return Math.abs(credit);
      }
      return false;
    },
  },
  methods: {
    goToNextStep() {
      this.errors = [];
      const has_missing_vagues = this.inscription.list_courses.check_missing_vagues_selection();
      if (has_missing_vagues) {
        this.errors.push("Vous devez choisir une vague de départ pour le parcours");
        return;
      }
      this.mainStore.bookingSystem.preselection = null;
      this.$emit("goToNextStep");
    },

    // Charge la selection de parcours de l'utilisateur
    async initialize() {
      // On charge les parcours ouverts si les parcours n'ont pas encore été chargés pour l'inscription
      await this.inscription.list_courses.initialize_from_mainstore(this.mainStore.module.courses.list);

      if (!this.initial_commande_inscription) {
        // On charge les packs de parcours si les packs n'ont pas encore été chargés pour l'inscription
        await this.inscription.list_packs_courses.initialize_from_mainstore(this.mainStore.module.packs_courses.list);
      }

      // Si on a une préselection faite sur la page d'accueil du module
      if (this.mainStore.bookingSystem.preselection) {

        this.inscription.setPreselection(this.mainStore.bookingSystem.preselection);
        this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
        this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
        this.inscription.update_cart("code_reduction");
        this.bookingStore.compute_cart();
        this.mainStore.bookingSystem.clearPreselectionOnSoloCourse();
      }
      this.inscription.handle_changement_parcours(this.initial_commande_inscription);
    },




    // Au click d'une checkbox de course, on l'ajoute à la selection de course de l'inscription
    updateSelectionCourse(index) {
      this.errors = [];
      const allow_multi_courses = this.mainStore.module.allow_multi_courses && !this.initial_commande_inscription;
      let response = this.inscription.toggle_course_selection(index, allow_multi_courses);
      if (!response.state) {
        this.errors = response.errors;
      }

      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
      const add_missing_inscriptions = true;
      this.mainStore.bookingSystem.equipes.assign_teams(add_missing_inscriptions);
    },

    // Au click d'une checkbox de pack, on l'ajoute à la selection de pack de l'inscription
    updateSelectionPack(index) {
      this.errors = [];
      let response = this.inscription.toggle_pack_selection(index);
      if (!response.state) {
        this.errors = response.errors;
      }

      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
    },

  },
  async created() {
    this.inscription = this.item;
    this.inscription.finished = false;
    this.initialize();
  },
};
</script>

<style lang="scss">
.radio_vagues.v-radio .v-label {
  justify-content: center !important;
}

.v-checkbox .v-selection-control {
  width: 100%;

}

.v-selection-control--inline .v-label {
  text-wrap: wrap;
}
</style>